import { analytics } from '@/lib/analytics'
import { api } from '@/lib/api/api'
import { ApiUserQuota } from 'sprites-types/api/user-quota'
import { ApiUser, ApiUserWorkspaceResponse, ApiWorkspace } from 'sprites-types/api/users'
import { signOut as supertokensSignOut } from 'supertokens-web-js/recipe/emailpassword'

export const userApi = api.injectEndpoints({
  endpoints: (builder) => ({
    signOut: builder.mutation<{ status: number; error: string }, void>({
      queryFn: async () => {
        analytics.userLifecycle.logout()
        await supertokensSignOut()
        analytics.reset()
        window.location.href = '/'
        return { data: { status: 200, error: 'Signed out' } }
      },
      invalidatesTags: ['User', 'UserQuota'],
    }),
    getUser: builder.query<{ user: ApiUser; workspace: ApiWorkspace }, void>({
      queryFn: async (_, _queryApi, _extraOptions, fetchWithBQ) => {
        // We have to fetch the user first, as it could generate an anonymous user.
        const userResponse = await fetchWithBQ('v1/users/me')

        if (userResponse.error) {
          return { error: userResponse.error }
        }

        const workspacesResponse = await fetchWithBQ('v1/users/me/workspace')

        if (workspacesResponse.error) {
          return { error: workspacesResponse.error }
        }
        if (!userResponse.data || !workspacesResponse.data) {
          return {
            error: {
              status: 401,
              data: { code: '401', message: 'Failed to fetch user or workspace' },
            },
          }
        }

        const user = userResponse.data as ApiUser
        const workspace = (workspacesResponse.data as ApiUserWorkspaceResponse).workspace

        analytics.identify(user.id, user.isAnonymous || false, {
          workspace_id: workspace.id,
          email: user.email,
          name: user.name,
        })

        return { data: { user, workspace } }
      },
      providesTags: ['User'],
    }),
    getUserQuota: builder.query<ApiUserQuota, void>({
      query: () => 'v1/users/me/quota',
      providesTags: ['UserQuota'],
    }),
  }),
})

export const {
  useGetUserQuotaQuery,
  useGetUserQuery,
  useSignOutMutation,
  useLazyGetUserQuery,
  useLazyGetUserQuotaQuery,
} = userApi
